"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultDictionary = void 0;
const React = require("react");
const index_1 = require("../index");
const useSearchResultDictionary = (selectedTab, configData, initialDictionary) => {
    const [isDictionaryLoaded, setIsDictionaryLoaded] = React.useState(true);
    const { filterDictionary, isFilterTranslationsLoading } = (0, index_1.usePortfolioFilterTranslation)(selectedTab, configData.language);
    const { countryFilterDictionary, isLoading: isCountryTranslationLoading } = (0, index_1.useCountryTranslation)({
        apiUrl: configData.locationApiUrl,
        locationApiKey: configData.locationApiKey,
        culture: configData.culture,
    });
    const { languageFilterDictionary, isLoading: isLanguageTranslationLoading } = (0, index_1.useLanguageTranslation)({
        apiUrl: configData.locationApiUrl,
        locationApiKey: configData.locationApiKey,
        culture: configData.culture,
    });
    React.useEffect(() => {
        if (!isFilterTranslationsLoading &&
            !isCountryTranslationLoading &&
            !isLanguageTranslationLoading) {
            setIsDictionaryLoaded(false);
        }
    }, [isFilterTranslationsLoading, isCountryTranslationLoading, isLanguageTranslationLoading]);
    return {
        dictionary: Object.assign(Object.assign(Object.assign(Object.assign({}, initialDictionary), filterDictionary), countryFilterDictionary), languageFilterDictionary),
        isDictionaryLoaded,
    };
};
exports.useSearchResultDictionary = useSearchResultDictionary;
